export default "__VITE_ASSET__CSCYmMIn__"